import { atom } from 'nanostores';
import type { FormFieldWithId } from '../components/ui/Form';
import type { DownloadFileFormModalType } from '../types/types';

type FormModalOptions = {
  formModal: DownloadFileFormModalType;
  formFieldsWithIds: Array<FormFieldWithId>;
} | null;

export const $formModalOptions = atom<FormModalOptions | null>(null);

export const openFormModal = (options: FormModalOptions) => {
  $formModalOptions.set(options);
  if (options) {
    window.history.pushState({}, '');
  }
};

export const closeFormModal = () => {
  $formModalOptions.set(null);
  window.history.back();
};
